export const IDENTITY_SOURCES = {
  GOOGLE_WORKSPACE: 'googleWorkspace',
  GITHUB: 'github',
  GCP: 'gcp',
  MICROSOFT: 'microsoft',
  AWS: 'aws',
  QALEA_PASS: 'qaleaPass',
  GITLAB: 'gitlab',
  AZURE: 'azure',
  HOLDED: 'holded',
  NOTION: 'notion',
  STRIPE: 'stripe',
  SLACK: 'slack',
  HUBSPOT: 'hubspot',
  OKTA: 'okta',
} as const

export const SOURCE_LABELS = {
  [IDENTITY_SOURCES.GOOGLE_WORKSPACE]: 'Google Workspace',
  [IDENTITY_SOURCES.GITHUB]: 'GitHub',
  [IDENTITY_SOURCES.GCP]: 'GCP',
  [IDENTITY_SOURCES.MICROSOFT]: 'Microsoft',
  [IDENTITY_SOURCES.AWS]: 'AWS',
  [IDENTITY_SOURCES.QALEA_PASS]: 'Qalea Pass',
  [IDENTITY_SOURCES.GITLAB]: 'Gitlab',
  [IDENTITY_SOURCES.AZURE]: 'Azure',
  [IDENTITY_SOURCES.HOLDED]: 'Holded',
  [IDENTITY_SOURCES.NOTION]: 'Notion',
  [IDENTITY_SOURCES.STRIPE]: 'Stripe',
  [IDENTITY_SOURCES.SLACK]: 'Slack',
  [IDENTITY_SOURCES.HUBSPOT]: 'Hubspot',
  [IDENTITY_SOURCES.OKTA]: 'Okta',
} as const

// How an identity is presented, derived from is_active and freshness rather than stored. A
// connector reports departure by writing is_active, and presence by refreshing last_seen; an
// account that stopped appearing in the sync is gone too, so both read as REMOVED. The reason it
// left is ours to reason about, not a distinction to put in front of a customer.
export const IDENTITY_STATES = {
  ACTIVE: 'active' as const,
  REMOVED: 'removed' as const,
} as const

export type IIdentityState = (typeof IDENTITY_STATES)[keyof typeof IDENTITY_STATES]

// NONE is not a quiet REMOVED: no connector ever reported an account, so there is no departure.
export const EMPLOYEE_IDENTITY_STATES = {
  ACTIVE: IDENTITY_STATES.ACTIVE,
  REMOVED: IDENTITY_STATES.REMOVED,
  NONE: 'none' as const,
} as const

export type IEmployeeIdentityState = (typeof EMPLOYEE_IDENTITY_STATES)[keyof typeof EMPLOYEE_IDENTITY_STATES]
